import { Component, OnInit } from '@angular/core';
import { User } from '../models/user.model';
import { NgForm, FormGroup, FormControl } from '@angular/forms';
import { UserService } from "../services/user.service";
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {

  signupForm: FormGroup;

  constructor(private userService: UserService, private notificationsService: ToastrService) { }

  ngOnInit() {
    this.signupForm = new FormGroup({
      email: new FormControl(),
      pasword: new FormControl(),
      confirmPasword: new FormControl()
    });
  }


  OnSubmit() {
    let user: User = new User();
    user.email = this.signupForm.get("email").value;
    user.password = this.signupForm.get("pasword").value;
    user.confirmPassword = this.signupForm.get("confirmPasword").value;

    this.userService.register(user).subscribe(
      (data: any) => {
      this.notificationsService.success("User registered");
      }
    );
  }
}
